export { StudentCoachPage, type StudentCoachPageProps, type UIStudentNoTutor } from "./StudentCoachPage"
export { StudentCoachTwoPane, type StudentCoachTwoPaneProps } from "./StudentCoachTwoPane"
